// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__1GlQQ","key":"key__t22eW","value":"value__3eMbV"};